/*
  Features that ship dark: merging to develop deploys, so what is not ready is switched on at build time only
  (REACT_APP_* variables are read when the application is built).

  Read at the moment of use, not when this file is loaded, so that a test can set them.
*/
const isOn = name => process.env[name] === 'true';

/* The simulation: sandboxes, runs and their results. REACT_APP_ENABLE_SIMULATION */
export const isSimulationEnabled = () => isOn('REACT_APP_ENABLE_SIMULATION');

/* "Test a change" in the simulation: the comparison of two runs. Needs the simulation. REACT_APP_ENABLE_SIMULATION_COMPARISON */
export const isComparisonEnabled = () =>
    isSimulationEnabled() && isOn('REACT_APP_ENABLE_SIMULATION_COMPARISON');

/* The audit screen: who did what, and when (and its entry in the sidebar, and *History* in the list of sandboxes). REACT_APP_ENABLE_AUDIT */
export const isAuditEnabled = () => isOn('REACT_APP_ENABLE_AUDIT');

/* The client access screen: the client credentials that send the events, and the brands each may send for. REACT_APP_ENABLE_CLIENT_ACCESS */
export const isClientAccessEnabled = () =>
    isOn('REACT_APP_ENABLE_CLIENT_ACCESS');

/*
  Logging in to a backend that checks passwords itself (no auth0 profile), which issues no token: the requests carry the password
  with HTTP Basic instead. For development only, on in `npm start` and in no other build. REACT_APP_ENABLE_LOCAL_AUTH
*/
export const isLocalAuthEnabled = () => isOn('REACT_APP_ENABLE_LOCAL_AUTH');
